// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <div class="info">
    <div class="info__column">
      <div class="info__field">
        <span class="info__field-label">Branch name:</span>
        <span class="info__field-value">{{\$ctrl.branch.name}}</span>
      </div>
      <div class="info__field">
        <span class="info__field-label">Branch code:</span>
        <span class="info__field-value">{{\$ctrl.branch.code}}</span>
      </div>
      <div class="info__field">
        <span class="info__field-label">Agent code:</span>
        <span class="info__field-value">{{\$ctrl.agent.code}}</span>
      </div>
      <div class="info__field" ng-if="\$ctrl.agent.brdReportId">
        <span class="info__field-label">BRD Report ID:</span>
        <span class="info__field-value">{{\$ctrl.agent.brdReportId}}</span>
      </div>
    </div>
  </div>

<div class="profile-body">
  <div class="tab-menu">
    <ul class="nav-tabs">
      <li class="active">
        <a data-target="#agent_credentials"
           data-toggle="tab">
          <span>
            <i ng-if="\$ctrl.credentialsForm.\$invalid"
               class="icon icon-warning-sign">
            </i>
            Credentials
          </span>
        </a>
      </li>
      <li>
        <a data-target="#new_agent_device"
           data-toggle="tab">
          <span>
            <i ng-if="\$ctrl.newDeviceForm.\$invalid || \$ctrl.isDeviceEdited"
               class="icon icon-warning-sign">
            </i>
            Devices
          </span>
        </a>
      </li>
    </ul>
  </div>
  <form name="\$ctrl.mainForm">
    <div class="tab-content user-details">
      <div id="agent_credentials"
           class="tab-pane active">
        <agents-credentials
          agent="\$ctrl.agent"
          ng-form="\$ctrl.credentialsForm"
          forced-password-update="true">
        </agents-credentials>
      </div>
      <div id="new_agent_device"
           class="tab-pane">
        <new-agent-device
          device="\$ctrl.device"
          ng-form="\$ctrl.newDeviceForm"
          is-device-edited="\$ctrl.isDeviceEdited">
        </new-agent-device>
      </div>

      <div class="buttons"
           ng-if="!\$ctrl.isDeviceEdited">
        <button class="btn btn-warning"
                ng-click="\$ctrl.redirectBack()">
          Cancel
        </button>
        <button type="submit"
                class="btn btn-primary"
                ng-click="\$ctrl.activate()"
                command-access="ActivateAgent"
                ng-disabled="\$ctrl.mainForm.\$invalid">
          Save
        </button>
      </div>
    </div>
  </form>
</div>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/agent-banking/activation/agent-activation.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;